import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, ListGroup, Alert } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';

const EmailTemplates = ({ active }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    content: '',
    isActive: false
  });
  const firstInputRef = useRef(null);
  const [editId, setEditId] = useState(null);

  // Token'ı localStorage'dan al
  const token = localStorage.getItem('token');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };

  useEffect(() => {
    fetchTemplates();
    // eslint-disable-next-line
  }, []);

  // Sekme aktif olduğunda ilk inputa focus ol
  useEffect(() => {
    if (active && firstInputRef.current) {
      setTimeout(() => {
        firstInputRef.current.focus();
      }, 100);
    }
  }, [active]);

  const fetchTemplates = async () => {
    try {
      const res = await axios.get('/api/email-templates', config);
      setTemplates(res.data.templates);
      setLoading(false);
    } catch (err) {
      setError('Template\'ler yüklenirken bir hata oluştu');
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleEdit = (template) => {
    setEditId(template._id);
    setFormData({
      name: template.name,
      subject: template.subject,
      content: template.content,
      isActive: template.isActive
    });
    setTimeout(() => {
      firstInputRef.current?.focus();
    }, 100);
  };

  const handleCancelEdit = () => {
    setEditId(null);
    setFormData({
      name: '',
      subject: '',
      content: '',
      isActive: false
    });
    setTimeout(() => {
      firstInputRef.current?.focus();
    }, 100);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`/api/email-templates/${editId}`, formData, config);
        toast.success('Template başarıyla güncellendi', { position: 'bottom-right' });
      } else {
        await axios.post('/api/email-templates', formData, config);
        toast.success('Template başarıyla oluşturuldu', { position: 'bottom-right' });
      }
      setFormData({
        name: '',
        subject: '',
        content: '',
        isActive: false
      });
      setEditId(null);
      fetchTemplates();
      setTimeout(() => {
        firstInputRef.current?.focus();
      }, 100);
    } catch (err) {
      toast.error('İşlem sırasında bir hata oluştu', { position: 'bottom-right' });
    }
  };

  const handleToggle = async (id) => {
    try {
      await axios.patch(`/api/email-templates/${id}/toggle`, {}, config);
      fetchTemplates();
      toast.success('Template durumu güncellendi', { position: 'bottom-right' });
    } catch (err) {
      toast.error('Template durumu güncellenirken bir hata oluştu', { position: 'bottom-right' });
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bu template\'i silmek istediğinizden emin misiniz?')) {
      try {
        await axios.delete(`/api/email-templates/${id}`, config);
        toast.success('Template başarıyla silindi', { position: 'bottom-right' });
        fetchTemplates();
      } catch (err) {
        toast.error('Template silinirken bir hata oluştu', { position: 'bottom-right' });
      }
    }
  };

  if (loading) return <div>Yükleniyor...</div>;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Container>
      <Row className="mb-4">
        <Col>
          <h2>E-mail Template Yönetimi</h2>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Card>
            <Card.Header>Yeni Template Oluştur</Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit} autoComplete="off">
                <Form.Group className="mb-3">
                  <Form.Label>Template Adı</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    autoFocus
                    autoComplete="off"
                    ref={firstInputRef}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>E-mail Başlığı</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="iReminder Hatırlatıcısı {{baslik}}"
                    required
                    autoComplete="off"
                  />
                  <Form.Text className="text-muted">
                    {'{{baslik}}'} değişkeni hatırlatma başlığı ile değiştirilecektir
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>E-mail İçeriği</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="content"
                    value={formData.content}
                    onChange={handleChange}
                    placeholder="<h2>{{baslik}}</h2><p>{{icerik}}</p>"
                    required
                    autoComplete="off"
                  />
                  <Form.Text className="text-muted">
                    {'{{icerik}}'} değişkeni hatırlatma içeriği ile değiştirilecektir
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Bu template'i aktif yap"
                    name="isActive"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                    autoComplete="off"
                  />
                </Form.Group>

                <Button variant="primary" type="submit">
                  {editId ? 'Güncelle' : 'Kaydet'}
                </Button>
                {editId && (
                  <Button variant="secondary" className="ms-2" onClick={handleCancelEdit} type="button">
                    İptal
                  </Button>
                )}
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card>
            <Card.Header>Mevcut Template'ler</Card.Header>
            <Card.Body>
              <ListGroup>
                {templates.map((template) => (
                  <ListGroup.Item key={template._id}>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h5>{template.name}</h5>
                        <p className="mb-1">
                          <strong>Başlık:</strong> {template.subject}
                        </p>
                        <small className="text-muted">
                          {template.isActive ? 'Aktif' : 'Pasif'}
                        </small>
                      </div>
                      <div>
                        <Button
                          variant={template.isActive ? 'warning' : 'success'}
                          size="sm"
                          className="me-2"
                          onClick={() => handleToggle(template._id)}
                        >
                          {template.isActive ? 'Pasif Yap' : 'Aktif Yap'}
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          className="me-2"
                          onClick={() => handleDelete(template._id)}
                        >
                          Sil
                        </Button>
                        <Button
                          variant="info"
                          size="sm"
                          onClick={() => handleEdit(template)}
                        >
                          Düzenle
                        </Button>
                      </div>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EmailTemplates; 